import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import '@/misc/unregister-all-service-worker'

// import '@/misc/register-service-worker'
// import '@/misc/handle-network-status'
// import '@/misc/handle-apple-install-prompt'
// import 'pwacompat'

import '@/misc/scrollTo'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
